import { FeatureToggleClientService } from 'feature-toggle-client';
const isJourneyAppEnabled = 'is-journey-app-enabled';
export class JourneyFeatures {
    static async isJourneyEnabled(botName) {
        try {
            const allFlags = FeatureToggleClientService.getInstance().getUserInstance().allFlags();
            const allowedBots = allFlags[isJourneyAppEnabled].bots;
            return allowedBots.includes(botName);
        }
        catch {
            return false;
        }
    }
}
